import './Links.scss'
import { motion } from 'framer-motion'

const Links = () => {
  return (
    <div className='work' id='work'>
      <h1>Important Links</h1>
      
      <div className='experience-wrapper'>
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            animate={{ borderRadius: 15}}
            className='experience-item'
          >
            <>
            <a style={{textDecoration: 'none', color: 'inherit', paddingBottom: '20px' }} href='https://www.sec.gov.bd' target="_blank">
                <img src='Assets/links (4).png' alt='Bangladesh Securities and Exchange Comission' />
                <p style={{ marginTop: 10, color: 'grey', textAlign: 'center' }}>
                    Bangladesh Securities and Exchange Comission
                </p>
            </a>
            </>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            animate={{ borderRadius: 15}}
            className='experience-item'
            
          >
            <>
            <a style={{textDecoration: 'none', color: 'inherit', paddingBottom: '20px' }} href='https://www.dsebd.org' target="_blank">
                <img src='Assets/links (3).png' alt='Dhaka Stock exchange' />
                <p style={{ marginTop: 10, color: 'grey', textAlign: 'center' }}>
                    Dhaka <br/>Stock exchange
                </p>
            </a>
            </>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            animate={{ borderRadius: 15}}
            className='experience-item'
          >
            <>
            <a style={{textDecoration: 'none', color: 'inherit', paddingBottom: '20px' }} href='https://www.cse.com.bd' target="_blank">
                <img src='Assets/links (1).png' alt='Chittagong Stock Exchange' />
                <p style={{ marginTop: 10, color: 'grey', textAlign: 'center' }}>
                    Chittagong Stock Exchange
                </p>
            </a>
            </>
          </motion.div>

          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: 'tween' }}
            animate={{ borderRadius: 15}}
            className='experience-item'
          >
            <>
            <a style={{textDecoration: 'none', color: 'inherit', paddingBottom: '20px' }} href='https://www.cdbl.com.bd' target="_blank">
                <img src='Assets/links (2).png' alt='Central Depository Bangladesh Limited' />
                <p style={{ marginTop: 10, color: 'grey', textAlign: 'center' }}>
                    Central Depository Bangladesh Limited
                </p>
            </a>
            </>
          </motion.div>
            
      </div>
    </div>
  )
}

export default Links
